import { Service } from "@/constants/cloud-apps.ts";
import { EmailAddInsProvider } from "@/constants/emails.ts";

export enum ProxySecurityMode {
  WARNING = "warning",
  BLOCK = "block",
}

export enum ProxyDirection {
  INBOUND = "inbound",
  OUTBOUND = "outbound",
}

export enum EmailProxyAction {
  ADD_DOMAIN = "addDomain",
  EDIT_DOMAIN = "editDomain",
  REMOVE_DOMAIN = "removeDomain",
  TEST_DOMAIN = "testDomain",
  TEST_DOMAIN_CONFIGURATION = "testDomainConfiguration",
  TEST_DOMAIN_CONNECTION = "testDomainConnection",
}

export enum ProxyStatus {
  NOT_TESTED = "notTested",
  PENDING = "pending",
  PASSED = "passed",
  FAILED = "failed",
  PASSED_CONFIGURATION = "passedConfiguration",
  FAILED_CONFIGURATION = "failedConfiguration",
  GRACE_PERIOD = "gracePeriod",
}

export enum ProxyError {
  DOMAIN_ALREADY_EXISTS = "domainAlreadyExists",
  PROXY_VERIFICATION_LINK_EXPIRED = "expiredProxyLink",
}

export enum OutboundGatewayAction {
  ADD_OUTBOUND_GATEWAY = "addOutboundGateway",
  EDIT_OUTBOUND_GATEWAY = "editOutboundGateway",
  TEST_OUTBOUND_GATEWAY = "testOutboundGateway",
  REMOVE_OUTBOUND_GATEWAY = "removeOutboundGateway",
  CONFIGURATION_REQUIRED = "configurationRequired",
  CONFIRM_BLOCK_MODE = "confirmBlockMode",
}

export const serviceToEmailProviderMap = {
  [Service.G_SUITE]: EmailAddInsProvider.GMAIL,
  [Service.OFFICE_365]: EmailAddInsProvider.OUTLOOK,
};

export enum ProxyTestType {
  INBOUND_CONFIGURATION = "inboundConfiguration",
  INBOUND_CONNECTION = "inboundConnection",
}
